export const API_URL = 'http://localhost:5050';
//export const API_URL = 'https://csc-server2.onrender.com';